import { render, staticRenderFns } from "./BaseButtonSubheader.vue?vue&type=template&id=46d6ce7d&scoped=true&"
import script from "./BaseButtonSubheader.vue?vue&type=script&lang=js&"
export * from "./BaseButtonSubheader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d6ce7d",
  null
  
)

export default component.exports